import { gql } from 'graphql-tag';

export default gql`
  query GetTrackPageLayout(
    $retailerMoniker: String!
    $versionName: String!
    $localeLanguage: Language
    $localeCountry: Country
    $status: String
    $category: String
    $type: String
    $cache: Boolean
  ) {
    retailerSettings(
      product: "narvarjs"
      retailerMoniker: $retailerMoniker
      versionName: $versionName
      localeLanguage: $localeLanguage
      localeCountry: $localeCountry
      status: $status
      category: $category
      type: $type
      cache: $cache
    ) {
      trackPageLayout
    }
  }
`;
